// El latido del servidor (/salud), compartido por la conexión, la franja de validación y lo que solo
// se muestra en VALIDACIÓN/DEV (la clasificación A/B/C de las pantallas). Una sola consulta.
import { useQuery } from '@tanstack/react-query';
import { api } from '../api/cliente';

export interface Salud {
  estado: string;
  ambiente: string;
  modoOperacion?: 'OFICIAL' | 'VALIDACION_OPERACIONAL' | 'UAT';
  /** Presentación de la instancia no oficial: PREPRODUCCION en erp.madeci.cl (solo rótulo). */
  entorno?: 'PREPRODUCCION';
  /** Validación / UAT: instante de la foto de stock heredada del sistema anterior (sin sincronización). */
  stockAl?: string | null;
  /** Última importación de precios y de la base de clientes (no hay sincronización). */
  preciosAl?: string | null;
  clientesAl?: string | null;
}

export function useSalud() {
  return useQuery({
    queryKey: ['conexion'],
    queryFn: () => api.get<Salud>('/salud'),
    refetchInterval: 30_000,
    retry: false,
  });
}

/** Instancia de PREPRODUCCIÓN (no oficial): cambia el rótulo, no las reglas. */
export const esPreproduccion = (s: Salud | undefined): boolean => s?.entorno === 'PREPRODUCCION';

/**
 * Modo revisión: VALIDACIÓN operacional o desarrollo local. Solo ahí se ve el estado del backend de
 * cada pantalla (A/B/C) y el mapa del ERP; en producción no.
 */
export function useModoRevision(): boolean {
  const salud = useSalud();
  return (
    import.meta.env.DEV ||
    salud.data?.modoOperacion === 'VALIDACION_OPERACIONAL' ||
    salud.data?.modoOperacion === 'UAT' ||
    (!!salud.data?.ambiente && salud.data.ambiente !== 'produccion')
  );
}
